var unirest = require("unirest");
const API = require("Api");

const apiBase = process.env.REACT_APP_API_BASE;
const apiv2 = process.env.REACT_APP_API_URL;

export async function searchStudents(token, calendarID, qryString) {
  const res = await unirest
    .get(apiBase + "search/students/" + qryString)
    .headers({
      Authorization: "Bearer " + token,
      crrntcal: calendarID,
      "Content-Type": "application/json",
    });
  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getCourses(token, calendarID) {
  const res = await unirest.get(apiv2 + "courses").headers({
    Authorization: "Bearer " + token,
    crrntcal: calendarID,
    "Content-Type": "application/json",
  });
  if (res.error) console.log(res.error);

  let list = res.body;
  return list;
}

export async function searchPersona(token, calendarID, srchQry) {
  const res = await unirest
    .get(API.V2 + API.PERSONAS + "search/" + srchQry)
    .headers({ Authorization: "Bearer " + token, crrntcal: calendarID });
  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}
